import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Provider,
  Flex,
  Button,
  Divider,
  Image,
  List,
  Avatar,
} from "@fluentui/react-northstar";
import { app, dialog } from "@microsoft/teams-js";
import { useState, useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import { ChevronStartIcon, AcceptIcon } from "@fluentui/react-icons-northstar";
import Slider from "../common/slider";
import _ from "lodash";
import { saveRecognitation } from "../../services/teamsbehaviour.service";
// import { getUserDetails } from "../../services/userDetails.service";
import ButtonComponent from "../common/button";
import Checkmark from "../../../web/assets/images/success-icon.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  saveRecipient,
  savesingleUserPoints,
  setPointsforEachUser,
  addPointsForCustomUser,
  checkBoxSelectionforRecipient,
  saveBehaviorInfo,
  setCheckboxPrivate,
  savePromotionId,
  saveCustomImageInfo,
  setAllPromotion,
  getAllPromotionsList,
  saveTeamMemberList,
  saveRecognizeList,
  saveFilters,
  setCopyManager,
  setCopyMe,
  setCopyOthersEmail,
  selectedParticipantId,
  saveCopyOthersRecipient,
} from "../../action/actionCreators";
import TextContent from "../common/Text";
import Bubbles from "../common/Bubbles";
import { refreshTokenGenerator } from "../../services/auth.service";
import { motion, AnimatePresence } from "framer-motion";
import { pageVariants, numberWithCommas } from "../common/utils";
import { useTranslation } from "react-i18next";
import { Config } from "../../../../app/server-config";

export const ReviewandSubmit = (props) => {
  const [{ inTeams, theme }] = useTeams();
  const history = useHistory();
  const [showRecognition, setshowRecognition] = useState(false);
  const state = useSelector((data: any) => data.commonReducer);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const listDataConversion = (data) => {
    const result = data.map((val) => {
      return {
        key: val.text,
        media: <Avatar name={val.text} />,
        header: (
          <TextContent content={val.text} className="bit_text_17 paxName" />
        ),
        content: (
          <TextContent
            className="bit_text_14 paxDetail"
            content={val.tertiaryText}
          />
        ),
        headerMedia: (
          <TextContent
            className="bit_text_14 paxDetail"
            content={
              val.budgetPoints !== undefined
                ? `${val.budgetPoints} ${t("Review.Points")}`
                : ""
            }
          />
        ),
      };
    });
    return result;
  };

  const onRecognitionSave = async () => {
    setLoading(!loading);
    const appToken = localStorage.getItem("appToken");
    const formData = new FormData();
    const mapData = state.promotion.awardAvailable
      ? state.singleMultiUserPoints
      : state.recepients;
    formData.append("promotionId", state.promotion.id);
    formData.append("nodeId", state.promotion.nodeId);
    formData.append("comments", state.behaviour.textArea);
    formData.append("sendCopyToManager", (state.copymanager || state?.promotion?.copyManagerAlways)  ? (state.copymanager || state?.promotion?.copyManagerAlways) : "");
    formData.append("sendCopyToMe", state.copyme ? state.copyme : "");
    formData.append("sendCopyToOthers", state.copyothersemail ? state.copyothersemail : "");
    for (let i = 0; i < state.copyOthersRecepients.length; i++) {
      if (state.copyOthersRecepients[i].key) {
        formData.append(`claimCopyOthersFormBeans[${i}].id`, state.copyOthersRecepients[i].key ? state.copyOthersRecepients[i].key.toString() : "");
      }
      if (state.copyOthersRecepients[i].firstName) {
        formData.append(`claimCopyOthersFormBeans[${i}].firstName`, state.copyOthersRecepients[i]?.firstName ? state.copyOthersRecepients[i]?.firstName.toString() : "");
      }
      if (state.copyOthersRecepients[i].lastName) {
        formData.append(`claimCopyOthersFormBeans[${i}].lastName`, state.copyOthersRecepients[i]?.lastName ? state.copyOthersRecepients[i]?.lastName.toString() : "");
      }
      if (state.copyOthersRecepients[i].email) {
        formData.append(`claimCopyOthersFormBeans[${i}].email`, state.copyOthersRecepients[i]?.email ? state.copyOthersRecepients[i]?.email?.toString() : "");
      }
      if (state.copyOthersRecepients[i].countryCode) {
        formData.append(`claimCopyOthersFormBeans[${i}].countryCode`, state.copyOthersRecepients[i]?.countryCode ? state.copyOthersRecepients[i]?.countryCode.toString() : "");
      }
      if (state.copyOthersRecepients[i].countryName) {
        formData.append(`claimCopyOthersFormBeans[${i}].countryName`, state.copyOthersRecepients[i]?.countryName ? state.copyOthersRecepients[i]?.countryName.toString() : "");
      }
      if (state.copyOthersRecepients[i].jobName) {
        formData.append(`claimCopyOthersFormBeans[${i}].jobName`, state.copyOthersRecepients[i]?.jobName ? state.copyOthersRecepients[i]?.jobName.toString() : "");
      }
      if (state.copyOthersRecepients[i].departmentName) {
        formData.append(`claimCopyOthersFormBeans[${i}].departmentName`, state.copyOthersRecepients[i]?.departmentName ? state.copyOthersRecepients[i]?.departmentName.toString() : "");
      }
      if (state.copyOthersRecepients[i].orgName) {
        formData.append(`claimCopyOthersFormBeans[${i}].orgName`, state.copyOthersRecepients[i]?.orgName ? state.copyOthersRecepients[i]?.orgName.toString() : "");
      }
    }
    if (_.size(state.manualImageInfo) > 0) {
      formData.append("cardType", "upload");
      formData.append(
        "cardUrl",
        _.size(state.manualImageInfo) > 0
          ? state.manualImageInfo.imageUrl
          : state.behaviour.image.largeImage
      );
    } else {
      formData.append("cardType", state.behaviour.image.cardType);
      formData.append("cardId", state.behaviour.image.id);
    }
    formData.append("selectedBehavior", state.behaviour.behaviour.id);
    formData.append("makeRecPrivate", state.private);

    mapData.map((val, index) => {
      formData.append("selectedBehavior", state.behaviour.behaviour.id);
      formData.append(`claimRecipientFormBeans[${[index]}].userId`, val.key);
      formData.append(`claimRecipientFormBeans[${[index]}].nodeId`, val.node);
      formData.append(
        `claimRecipientFormBeans[${[index]}].countryCode`,
        val.countryCode
      );
      if (!val.optOutAwards) {
        formData.append(
          `claimRecipientFormBeans[${[index]}].awardQuantity`,
          val.value !== undefined ? val.value : ""
        );
      }
    });

    const result = await saveRecognitation(formData);
    const data = {
      image:
        _.size(state.manualImageInfo) > 0
          ? state.manualImageInfo.videoUrl || state.manualImageInfo.imageUrl
          : state.behaviour.image.largeImage,
      count: state.recepients.length,
      message: state.behaviour.textArea,
      userDetails: state.userDetails.clientName,
      token: localStorage.getItem("appToken"),
      host: localStorage.getItem("host"),
      context: localStorage.getItem("context"),
    };
    dispatch(saveRecognizeList(data));
    if (result && result.data) {
      // if valid token this section will execute
      // tslint:disable: no-shadowed-variable
      const { data } = result;
      if (data && data.success === true) {
        setLoading(!loading);
        setshowRecognition(!showRecognition);
      }
    } else {
      // for refreshToken section... token fails then this section will execute.
      const appToken = localStorage.getItem("appToken");
      refreshToken(appToken, formData);
    }
  };
  // for geting refresh token
  const refreshToken = async (token, formData) => {
    const tokenResponse = await refreshTokenGenerator(token);
    if (tokenResponse.status === 200) {
      localStorage.setItem("appToken", tokenResponse.data.token);
      const result = await saveRecognitation(formData);
      if (result && result.data) {
        const { data } = result;
        if (data && data.success === true) {
          setLoading(!loading);
          setshowRecognition(!showRecognition);
        }
      }
    }
  };

  const gotoPromotionPage = () => {
    const appToken = localStorage.getItem("appToken");
    const host = localStorage.getItem("host");
    const context = localStorage.getItem("context");
    dispatch(saveRecipient([]));
    dispatch(savesingleUserPoints({}));
    dispatch(setPointsforEachUser([]));
    dispatch(addPointsForCustomUser({}));
    dispatch(checkBoxSelectionforRecipient(false));
    dispatch(setCopyManager(false));
    dispatch(setCopyMe(false));
    dispatch(setCopyOthersEmail(""));
    dispatch(selectedParticipantId([]));
    dispatch(saveCopyOthersRecipient([]));
    dispatch(saveBehaviorInfo({}));
    dispatch(savePromotionId({}));
    dispatch(saveCustomImageInfo({}));
    dispatch(setCheckboxPrivate(false));
    dispatch(setAllPromotion([]));
    dispatch(getAllPromotionsList([]));
    dispatch(saveTeamMemberList([]));
    dispatch(
      saveFilters({
        jobTitle: "",
        department: "",
        location: "",
        country: "",
        group: "",
      })
    );
    history.push({
      pathname: `/promotions/${appToken}/${host}/${context}`,
    });
  };

  const goBack = () => {
    history.goBack();
  };

  const gotoEditPointsPage = () => {
    history.push({
      pathname: "/addrecipients",
    });
  };
  const gotoRecipientPage = () => {
    history.push({
      pathname: "/search/:token",
    });
  };

  const gotoBehavior = () => {
    history.push({
      pathname: "/addbehaviours",
    });
  };

  const onPostIntoWall = () => {
    setDisable(true);
    app.getContext()
    .then((context) => {
      dialog.url.submit(state.submittedRecognizeList, Config.MICROSOFT_APP_ID());
    })
    .catch((error) => {
        console.error("Failed to get context:", error);
    });
  };

  return (
    <motion.div initial="out" animate="in" exit="out" variants={pageVariants}>
      <Provider
        theme={theme}
        className="reviewProvider recognitionPage appProvider mg-top-2rem"
      >
        {!showRecognition ? (
          <div>
            <div className="mg-l-5 mg-b-2rem">
              <TextContent
                // content="Review your recognition"
                content={t("Review.Header")}
                className="bit_text_18 bit_text_bold"
              />
            </div>
            <Divider />
            {state.recepients.length > 0 && (
              <div>
                <div className="review-recepient-wrapper">
                  <div className="review_header">
                    <Flex
                      space="between"
                      gap="gap.medium"
                      padding="padding.medium"
                    >
                      <TextContent
                        content={
                          state.recepients.length === 1
                            ? `${state.recepients.length} ${t(
                              "Participants.Recipient"
                            )}`
                            : `${state.recepients.length} ${t(
                              "Participants.Recipients"
                            )}`
                        }
                        weight="regular"
                      />
                      <Flex gap="gap.smaller" className="mg-r-5">
                        <Button
                          size="medium"
                          content={t("Review.Edit")}
                          onClick={gotoRecipientPage}
                        />
                      </Flex>
                    </Flex>
                  </div>
                  <div className="review_recipient">
                    <List
                      items={
                        state.promotion.awardAvailable
                          ? listDataConversion(state.singleMultiUserPoints)
                          : listDataConversion(state.recepients)
                      }
                      className="list-width"
                    />
                  </div>
                </div>
                {state.promotion.awardAvailable && (
                  <>
                    <Divider />
                    <div className="review-recepient-wrapper">
                      <div className="review_header">
                        <Flex
                          space="between"
                          gap="gap.medium"
                          padding="padding.medium"
                        >
                          <TextContent content={"AWARDS"} weight="regular" />
                          <Flex gap="gap.smaller" className="mg-r-5">
                            <Button
                              size="medium"
                              content={t("Review.Edit")}
                              onClick={gotoEditPointsPage}
                            />
                          </Flex>
                        </Flex>
                      </div>
                      <div className="review_slider">
                        {state.promotion.budgetInfo != null ?

                          <Slider
                            defaultValue={state.sum}
                            max={state?.promotion?.budgetInfo?.currentValue}
                            custom={true}
                            customText={
                              <TextContent
                                className="blue-light-1"
                                style={{ fontSize: "12px" }}
                                content={
                                  (
                                    state?.promotion?.budgetInfo?.currentValue -
                                    state.sum
                                  ).toLocaleString() +
                                  ` ${t("Review.PointsRemaining")}`
                                }
                              />
                            }
                            title={
                              <TextContent
                                weight="bold"
                                style={{ fontSize: "14px" }}
                                content={`${numberWithCommas(state.sum)} ${t(
                                  "Review.PointsAwarded"
                                )}`}
                              />
                            }
                            discretionaryText={`${state.promotion.name}`}
                          /> :
                          <Slider
                            defaultValue={state.sum}
                            max={state?.sum}
                            custom={true}
                            customText={
                              <TextContent
                                className="blue-light-1"
                                style={{ fontSize: "14px" }}
                                content={`${state.promotion.name}`}
                              />
                            }
                            title={
                              <TextContent
                                weight="bold"
                                style={{ fontSize: "14px" }}
                                content={`${numberWithCommas(state.sum)} ${t(
                                  "Review.PointsAwarded"
                                )}`}
                              />
                            }
                          />
                        }
                      </div>

                    </div>
                  </>
                )}
                <Divider />
                <div className="review-recepient-wrapper">
                  <div className="review_header">
                    <Flex
                      space="between"
                      gap="gap.medium"
                      padding="padding.medium"
                    >
                      <TextContent
                        content={t("Review.MessageHeader")}
                        weight="regular"
                      />
                      <Flex gap="gap.smaller" className="mg-r-5">
                        <Button
                          size="medium"
                          content={t("Review.Edit")}
                          onClick={gotoBehavior}
                        />
                      </Flex>
                    </Flex>
                  </div>
                  <div className="row review_message-wrapper">
                    <div className="column">
                      {state.behaviour.behaviour && (
                        <p className="ao eh">
                          {
                            state.behaviour.behaviour.img !== null && 
                            <Avatar
                            image={state.behaviour.behaviour.img}
                            name={state.behaviour.behaviour.name}
                          />
                          }                          
                          <TextContent
                            content={state.behaviour.behaviour.name}
                            weight="bold"
                          />
                        </p>
                      )}
                      <TextContent
                        content={
                          state.behaviour.textArea !== "" &&
                          `${state.behaviour.textArea}`
                        }
                        weight="semibold"
                        className={`review_message ${_.size(state.behaviour.image) > 0 ||
                            _.size(state.manualImageInfo) > 0
                            ? `review_message_80`
                            : "review_message_full"
                          }`}
                      /><br />
                     {
                      (state.copyme || state.copymanager || state?.promotion?.copyManagerAlways || state.copyothersemail.length > 0 || state.copyOthersRecepients.length > 0) && (
                        <div>
                          {state.copyme ? (
                            <>
                              <TextContent content={t("Review.RECIPIENT_COPY_TO_YOU")} />
                              <br />
                            </>
                          ) : null}

                          {state.copymanager || state?.promotion?.copyManagerAlways ? (
                            <>
                              <TextContent content={t("Review.COPY_TO_MANAGER")} />
                              <br />
                            </>
                          ) : null}

                          {((state.copyOthersRecepients && state.copyOthersRecepients.length > 0 && state.copyOthersRecepients.some((item) => item.email !== "")) || (state.copyothersemail && state.copyothersemail.length > 1)) && (
                            <>
                              <TextContent content={t("Review.COPY_TO_OTHERS")} />
                              <br />
                            </>
                          )}

                          {state.copyOthersRecepients && state.copyOthersRecepients.length > 0 ? (
                            state.copyOthersRecepients.map((item: any) => (
                              <p key={item.key}>{item.email}</p>
                            ))
                          ) : (
                            <p></p>
                          )}

                          {state.copyothersemail.length > 1 ? (
                            <div className="copy-wrap">
                              {location?.state?.copyEmail.length > 0 ? (
                                location?.state?.copyEmail.map((item: any, i) => (
                                  <p>{item}</p>
                                ))
                              ) : (
                                <p></p>
                              )}
                            </div>
                          ) : null}
                        </div>
                      )
                    }
                      {state.private && (
                        <Button
                          icon={<AcceptIcon size="small" />}
                          text
                          disabled
                          content={t("Review.Private")}
                          className="recognition_private"
                        />
                      )}
                    </div>
                    <div className="mg-r-6">
                      {_.size(state.behaviour.image) > 0 ? (
                        <Image src={state.behaviour.image.smallImage} style={{ float: "right", width: "144px" }} />
                      ) : (
                        <div>
                          {_.size(state.manualImageInfo) > 0 ? (
                            <Image
                              src={
                                state.manualImageInfo.videoUrl
                                  ? state.manualImageInfo.videoUrl
                                  : state.manualImageInfo.imageUrl
                              }
                              style={{ float: "right" }}
                              width="144"
                              height="144"
                            />
                          ) : null}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <Divider />
                <div className="footer">
                  <Flex space="between">
                    <Button
                      icon={<ChevronStartIcon size="large" />}
                      iconOnly
                      tinted
                      title={t("Review.Back")}
                      content={t("Review.Back")}
                      onClick={goBack}
                      className="mg-l-5 bit-pad-10"
                      style={{ border: "1px #6264a7 solid" }}
                      size="medium"
                    />
                    <Flex gap="gap.smaller" className="mg-r-5">
                      <Button
                        primary
                        size="medium"
                        title={t("Review.Send")}
                        content={t("Review.Send")}
                        onClick={onRecognitionSave}
                        disabled={loading}
                      />
                    </Flex>
                  </Flex>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="finalScreen">
            <Bubbles />
            <section className="imageContaniner">
              <div className="successWrap">
                <Image src={Checkmark} className="checkmark" />
                {state.recepients.length > 0 && state.recepients.length === 1 && (
                  <p className="recognition-success bit_text_18">
                    {t("FinalPage.Header")} {t("FinalPage.To")}{" "}
                    <span className="bit_text_bold">
                      {" "}
                      {state.recepients[0].text}{" "}
                    </span>{" "}
                  </p>
                )}
                {state.recepients.length > 1 && (
                  <p className="recognition-success bit_text_18">
                    {t("FinalPage.Header")} {t("FinalPage.To")}{" "}
                    <span className="bit_text_bold">
                      {" "}
                      {state.recepients[0].text}{" "}
                    </span>{" "}
                    {t("FinalPage.AND")}{" "}
                    <span className="bit_text_bold">
                      {" "}
                      {state.recepients.length - 1} {t("FinalPage.OTHERS")}
                    </span>{" "}
                  </p>
                )}
              </div>
            </section>
            <div className="footer">
              <Flex space="between" className="mg-l-5">
                <Button
                  content={t("FinalPage.Sendanother")}
                  onClick={gotoPromotionPage}
                  fluid
                  styles={{ maxWidth: "210px" }}
                />
                <Flex gap="gap.smaller" className="mg-r-5">
                  <Button
                    primary
                    size="medium"
                    content={t("FinalPage.Done")}
                    onClick={onPostIntoWall}
                    disabled={disable}
                  />
                </Flex>
              </Flex>
            </div>
          </div>
        )}
      </Provider>
    </motion.div>
  );
};
